import React, { useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from 'react-redux';
import Question from "../components/Question";
import MoveButton from "../components/MoveButton";
import { Stack, Box, useTheme, useMediaQuery } from "@mui/material";
import { setSkippedInsurance as updateSkippedInsurance } from "../redux/userSlice";
import { continueButtonSx } from '../lib/uiformatting';
import ContinueButton from '../components/ContinueButton';
import { useSelector } from 'react-redux';
import setPageAndDeferNavigate from "../lib/setPageAndDeferNavigate";

export default function InsuranceDetailMethod() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
    const [insuranceMethod, setInsuranceMethod] = useState(null);
    const location = useLocation();

    const { returning = false } = location.state || {};

    const insurance = useSelector((state) => state.insurance);

    const options = {
        "Upload Photos": "Upload Photos",
        "Enter Member ID": "Enter Member ID",
    };

    const handleClick = (option) => {
        setInsuranceMethod(options[option]);
        if (options[option] === "Upload Photos") {
            setPageAndDeferNavigate(dispatch, '/insurance/photos', navigate);
        } else {
            setPageAndDeferNavigate(dispatch, '/insurance/info', navigate);
        }
    };

    const handleBack = () => {
        setPageAndDeferNavigate(dispatch, '/insurance/provider', navigate);
    };

    return (
        <Question
            onBack={handleBack}
            title="Please select your preferred method to upload insurance information."
            subtitle="Select One"
            input={
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    width="100%"
                >
                    <Stack
                        spacing={2}
                        width="100%"
                        maxWidth={isDesktop ? "400px" : "100%"}
                        alignItems="center"
                    >
                        {Object.keys(options).map((option) => (
                            <MoveButton
                                key={option}
                                sx={{
                                    width: '100%',
                                    maxWidth: '400px',
                                }}
                                onClick={() => handleClick(option)}
                                title={option}
                                selected={insuranceMethod === options[option]}
                            />
                        ))}
                    </Stack>
                </Box>
            }
            footer={
                insurance.insurer !== "Blue Cross Blue Shield PPO" && (
                    <Box sx={{ ...continueButtonSx }}>
                        <ContinueButton
                            onClick={() => {
                                dispatch(updateSkippedInsurance(true));
                                if (returning) {
                                    setPageAndDeferNavigate(dispatch, '/anything-else-toknow', () =>
                                        navigate('/anything-else-toknow', { state: { returning: true } })
                                    );
                                } else {
                                    setPageAndDeferNavigate(dispatch, '/whats-next', navigate);
                                }
                            }}
                            title="Add it later"
                            selected={true}
                        />
                    </Box>
                )
            }
        />
    );
}